export default "__VITE_ASSET__CKk1qsbB__"